import React from "react";
import { Icon } from "../../UIElements/Icon";

const UsersError = ({ error, onRetry }) => {
  const getErrorMessage = () => {
    if (error?.message) {
      return error.message;
    }
    if (error?.status === 404) {
      return "Users endpoint not found";
    }
    if (error?.status === 403) {
      return "You do not have permission to view users";
    }
    if (error?.status >= 500) {
      return "Server error occurred while loading users";
    }
    return "An error occurred while loading users";
  };

  return (
    <div className="py-12 text-center">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-500/10">
        <Icon name="AlertCircle" className="h-8 w-8 text-red-400" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-white">
        Error Loading Users
      </h3>
      <p className="mx-auto mb-6 max-w-md text-gray-400">{getErrorMessage()}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center rounded-lg bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700"
        >
          <Icon name="RefreshCw" className="mr-2 h-4 w-4" />
          Try Again
        </button>
      )}
    </div>
  );
};

export default UsersError;
